module.exports = __webpack_public_path__ + "static/img/b18.8d1b938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b18.jpg
// module id = BuZh
// module chunks = 1